export interface ValueCardProps {
  title: string
  description: any
  icon: string
  iconPrefix: string
}

export const useValueCard = (props: ValueCardProps) => {
  return {
    ...props,
  }
}
